import { sendNewRelicEvent } from '../../scripts/utilities/newrelic/newrelic-micro-sendEvent.js';
import { RESULT_STATE } from '../../scripts/utilities/newrelic/newrelic-constants.js';
import asyncActionTypes from '../actions/types.js';

const initialState = {
  duplicateEmailEnrollment: undefined,
  duplicateTutorEnrollment: undefined,
  enrollmentServiceError: false,
  userRecoveryPasswordLoading: false,
  apiError: null,
};

const userProfileLogin = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.ENROLLMENT_ERROR:
      return {
        ...state,
        enrollmentServiceError: initialState.enrollmentServiceError,
        apiError: { actionType: action.type, errorData: action.payload },
      };
    case asyncActionTypes.USER_LOGIN:
      return {
        ...state,
        userLoginLoading: true,
        userToken: action.userToken,
      };
    case asyncActionTypes.RECOVERY_USER_PASSWORD:
      return {
        ...state,
        userRecoveryPasswordLoading: true,
      };
    case asyncActionTypes.VALIDATE_EMAIL.START:
      return {
        ...state,
        duplicateEmailEnrollment: {
          value: undefined,
        },
        apiError: null,
      };
    case asyncActionTypes.VALIDATE_EMAIL.FAIL:
      sendNewRelicEvent({
        actionType: 'USER_ENROLLMENT',
        funnel: 'Validate Email',
        state: action?.store,
        result: action?.payload,
        resultState: RESULT_STATE.FAILURE,
      });

      return {
        ...state,
        duplicateEmailEnrollment: {
          copyID: action.copyID,
          value: action.duplicateEmail,
        },
        enrollmentServiceError: action.enrollmentServiceError,
        apiError: { actionType: action.type, errorData: action.payload },
      };
    case asyncActionTypes.VALIDATE_EMAIL.SUCCESS:
      sendNewRelicEvent({
        actionType: 'USER_ENROLLMENT',
        funnel: 'Validate Email',
        state: action?.store,
        result: action?.payload,
        resultState: RESULT_STATE.SUCCESS,
      });

      return {
        ...state,
        duplicateEmailEnrollment: {
          value: undefined,
        },
        enrollmentServiceError: initialState.enrollmentServiceError,
        apiError: null,
      };
    case asyncActionTypes.VALIDATE_TUTOR.START:
      return {
        duplicateTutorEnrollment: initialState.duplicateTutorEnrollment,
        enrollmentServiceError: initialState.enrollmentServiceError,
        apiError: null,
      };
    case asyncActionTypes.VALIDATE_TUTOR.FAIL:
      sendNewRelicEvent({
        actionType: 'USER_ENROLLMENT',
        funnel: 'Validate Tutor',
        state: action?.data?.store,
        result: action?.payload,
        resultState: RESULT_STATE.FAILURE,
        guardianAccount: action?.data?.guardianAccount,
      });

      return {
        ...state,
        duplicateTutorEnrollment: {
          copyID: action.copyID,
          value: action.guardianAccount,
        },
        enrollmentServiceError: action.enrollmentServiceError,
        apiError: { actionType: action.type, errorData: action.payload },
      };
    case asyncActionTypes.VALIDATE_TUTOR.SUCCESS:
      sendNewRelicEvent({
        actionType: 'USER_ENROLLMENT',
        funnel: 'Validate Tutor',
        state: action?.store,
        result: action?.payload,
        resultState: RESULT_STATE.SUCCESS,
        guardianAccount: action?.guardianAccount,
      });

      return {
        ...state,
        duplicateTutorEnrollment: {
          value: undefined,
        },
        enrollmentServiceError: initialState.enrollmentServiceError,
        apiError: null,
      };
    default:
      return state;
  }
};

export default userProfileLogin;
